(function () {
  var raf = requestAnimationFrame;

  function updateProgress(viewport, segments, total) {
    var w = viewport.clientWidth;
    if (!w || !segments.length) return;
    var realIdx = ((Math.round(viewport.scrollLeft / w) - 1) % total + total) % total;
    for (var i = 0; i < segments.length; i++) {
      segments[i].classList.toggle("is-active", i === realIdx);
    }
  }

  function bindCarousel(wrap) {
    if (!wrap || wrap.dataset.productCardCarouselInit === "true") return;

    // --- KILL SWITCH FOR RECENTLY VIEWED PRODUCTS ---
    // This stops the carousel rendering logic if the product item lives inside the recently viewed section
    if (wrap.closest('.recently-viewed-products') || wrap.closest('[data-section-type="recently-viewed-products"]')) {
      return;
    }

    var viewport = wrap.querySelector("[data-carousel-viewport]");
    var progress = wrap.querySelector("[data-carousel-progress]");
    if (!viewport || !progress) return;

    var segments = progress.querySelectorAll(".product-item__mobile-card-carousel-progress-seg");
    if (!segments.length) return;

    var realSlides = viewport.querySelectorAll(".product-item__mobile-card-carousel-slide");
    var total = realSlides.length;
    if (total < 2) return;

    // Clone only first and last — reuse existing nodes
    var firstClone = realSlides[0].cloneNode(true);
    var lastClone = realSlides[total - 1].cloneNode(true);
    firstClone.setAttribute("aria-hidden", "true");
    lastClone.setAttribute("aria-hidden", "true");
    viewport.insertBefore(lastClone, realSlides[0]);
    viewport.appendChild(firstClone);

    wrap.dataset.productCardCarouselInit = "true";

    // Jump to real first slide silently
    viewport.style.scrollBehavior = "auto";
    viewport.scrollLeft = viewport.clientWidth;
    viewport.style.scrollBehavior = "";

    var ticking = false;
    var loopTimer = null;

    function onScroll() {
      // Progress update — throttled via rAF
      if (!ticking) {
        raf(function () {
          updateProgress(viewport, segments, total);
          ticking = false;
        });
        ticking = true;
      }

      // Loop check — debounced, only fires after scroll settles
      clearTimeout(loopTimer);
      loopTimer = setTimeout(function () {
        var slideW = viewport.clientWidth;
        if (!slideW) return;
        var idx = Math.round(viewport.scrollLeft / slideW);
        if (idx === 0) {
          viewport.style.scrollBehavior = "auto";
          viewport.scrollLeft = total * slideW;
          viewport.style.scrollBehavior = "";
        } else if (idx === total + 1) {
          viewport.style.scrollBehavior = "auto";
          viewport.scrollLeft = slideW;
          viewport.style.scrollBehavior = "";
        }
      }, 50);
    }

    viewport.addEventListener("scroll", onScroll, { passive: true });

    if (typeof ResizeObserver !== "undefined") {
      new ResizeObserver(function () {
        var slideW = viewport.clientWidth;
        var idx = Math.round(viewport.scrollLeft / slideW);
        viewport.style.scrollBehavior = "auto";
        viewport.scrollLeft = idx * slideW;
        viewport.style.scrollBehavior = "";
      }).observe(viewport);
    }

    window.addEventListener("orientationchange", function () {
      raf(function () { updateProgress(viewport, segments, total); });
    });
  }

  function init(root) {
    (root || document).querySelectorAll("[data-product-card-carousel]").forEach(bindCarousel);
  }

  var debounceId;
  function scheduleInit() {
    clearTimeout(debounceId);
    debounceId = setTimeout(function () { init(document); }, 40);
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function () { init(document); });

  if (typeof MutationObserver !== "undefined") {
    document.querySelectorAll(".collection__infinite-container, .search__infinite-container, [data-partial]").forEach(function (el) {
      new MutationObserver(scheduleInit).observe(el, { childList: true });
    });
  }
})();